import router from './router/index'
import common from '../common/common.main'
const app = common()
app.use(router).mount('#app')
